import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../Breadcumb/Main'

const Team = () => {
  return (
    <>
    <Breadcumb Title="Our Team" Breadcumb="OUR TEAM" />
    <section className="section-padding--bottom section-padding--top">
			<div className="container">
				<div className="section-title text-center">
					<p className="section-title__text">Our Team members</p>
					<h2 className="section-title__title">Our Expert Person to Provide <br /> IT Solution Services</h2>
				</div>
				<div className="row gutter-y-30">
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-1.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Michelle Monaghan</Link></h3>
								
								<p className="team-card-one__designation">Designer</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="100ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-2.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Jessica Brown</Link></h3>
								
								<p className="team-card-one__designation">Manager</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-3.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Kevin Martin</Link></h3>
								
								<p className="team-card-one__designation">Developer</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-4.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Sarah Albert</Link></h3>
								
								<p className="team-card-one__designation">Director</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="400ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-5.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Mike Hardson</Link></h3>
								
								<p className="team-card-one__designation">Designer</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12">
						<div className="team-card-one wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="500ms">
							<div className="team-card-one__image">
								<img src="assets/images/team/team-1-6.jpg" alt="" />
								<div className="team-card-one__social">
									<ul className="team-card-one__social__links">
										<li><Link to="#"><i className="fab fa-twitter"></i></Link></li>
										<li><Link to="#"><i className="fab fa-facebook"></i></Link></li>
										<li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>
										<li><Link to="#"><i className="fab fa-instagram"></i></Link></li>
									</ul>
									<div className="team-card-one__social__icon">
										<i className="fa fa-share-alt"></i>
									</div>
								</div>
							</div>
							<div className="team-card-one__content">
								<h3 className="team-card-one__title"><Link to="#">Christine Eve</Link></h3>
								
								<p className="team-card-one__designation">IT Expert</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
  )
}

export default Team